import UltMeta, { Meta } from "./UltMeta/index";

// 机构认证状态
class InstitutionState extends UltMeta {
    PENDING_APPROVE = new Meta(1, "待审核");
    REJECTED = new Meta(2, "已驳回");
    APPROVED = new Meta(3, "已通过");
}

export const INSTITUTION_STATE = new InstitutionState();

// 授权状态
class AuthorizationState extends UltMeta {
    NONE = new Meta(1, "--");
    UNAUTHORIZED = new Meta(2, "未授权");
    AUTHORIZED = new Meta(3, "已授权");
}

export const AUTHORIZATION_STATE = new AuthorizationState();
